import React, {useState, useEffect} from 'react';
import { encodeParams } from '../../utils';
import VersionsListContainer from '../../components/common/containers/VersionsListContainer';
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import StyledFormControl from '../../components/common/StyledFormControl';
import { connect } from 'react-redux';
import { orderDataOfficialNameChanged } from '../actions/instuctionActions';

function InstructionGeneratorStaticFields(props) {
  const [calculatedOrderNumber, setCalculatedOrderNumber] = useState("");

  const updateOrderDataOfficialName = (value) => { props.dispatch(orderDataOfficialNameChanged(value)); };

  useEffect(() => {
    const orderNumber = props.orderData.orderNumbers;
    if (orderNumber) {
        setCalculatedOrderNumber(orderNumber.isStandingOrder ? orderNumber.standingOrderNumber : (
        orderNumber.isInternalOrder ? orderNumber.internalOrderNumber : orderNumber.orderNumber
      ));
    }
  }, [props.orderData]);

  return (
    <div>
      <h2>WORK INSTRUCTION</h2>
      <VersionsListContainer
        versions={props.versions}
        makeUrl={(i, versionId) =>
          i === 0
            ? encodeParams`/dashboard/instruction-generator/create/order/${props.orderData._id}`
            : encodeParams`/dashboard/instruction-generator/create/order/${props.orderData._id}/version/${versionId}`
        }
      />
      <div className="flex-row">
        <FormGroup>
          <ControlLabel>Official order name</ControlLabel>
          <StyledFormControl
            disabled={false}
            value={props.orderData.officialName}
            onChange={(ev) => updateOrderDataOfficialName(ev.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Order</ControlLabel>
          <FormControl
            type="text"
            disabled={true}
            value={calculatedOrderNumber}
            // onChange={ev => props.standingOrderNumberChanged(ev.target.value)}
          />
        </FormGroup>
      </div>
    </div>
  )
}

function mapStateToProps ({ instructionsReducer }) {
  return {
    ...instructionsReducer
  };
}

const mapDispatchToProps = (dispatch) => {
  return { dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(InstructionGeneratorStaticFields);
